module.exports = __webpack_public_path__ + "static/img/smartility_admin.e090022.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/smartility_admin.png
// module id = 380
// module chunks = 29